// Dates des instances : remise en trafic / date limite avant retour.
const pad = (n) => String(n).padStart(2, "0");
export const isoLocal = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const aujourdhui = () => isoLocal(new Date());
export function plusJours(n, depuis = new Date()) {
  const d = new Date(depuis.getFullYear(), depuis.getMonth(), depuis.getDate() + n);
  return isoLocal(d);
}
export function lundiProchain() {
  const d = new Date();
  const n = ((8 - d.getDay()) % 7) || 7;
  return plusJours(n);
}
export function fmtJour(iso, long = false) {
  if (!iso) return "—";
  const [y, m, j] = iso.split("-").map(Number);
  const d = new Date(y, m - 1, j);
  return d.toLocaleDateString("fr-FR", long ? { weekday: "long", day: "numeric", month: "long" } : { weekday: "short", day: "2-digit", month: "2-digit", year: "numeric" });
}

// Dead line (Problème adresse, Cassé, RTS) : J+1 à J+5, J+5 par défaut.
export const DEADLINE_MAX_JOURS = 5;
export const raccourcisDeadline = () => [1, 2, 3, 4, 5].map((n) => [`${n} j`, plusJours(n)]);

export const TYPES_DATE = {
  remise: { label: "Remise en trafic", court: "Remise en trafic" },
  limite: { label: "Date limite avant retour", court: "Date limite" },
};

/** Texte relatif (« demain », « J-3 », « dépassée de 2 j »…). */
export function relatif(e) {
  if (!e) return "";
  const n = e.jours;
  if (e.type === "remise") {
    if (n < 0) return `en retard de ${-n} j`;
    if (n === 0) return "aujourd'hui";
    if (n === 1) return "demain";
    return `dans ${n} j`;
  }
  if (n < 0) return `dépassée de ${-n} j — à retourner`;
  if (n === 0) return "dernier jour";
  return `J-${n}`;
}

/** Jours restants jusqu'à une date (AAAA-MM-JJ). */
export function joursAvant(iso) {
  if (!iso) return null;
  const [y, m, j] = iso.split("-").map(Number);
  const t = new Date(); t.setHours(0, 0, 0, 0);
  return Math.round((new Date(y, m - 1, j) - t) / 86400000);
}

export const STYLE_ETAT = {
  aujourdhui: "bg-sky-500/15 text-sky-600 dark:text-sky-400 border-sky-500/30",
  en_retard: "bg-orange-500/15 text-orange-600 dark:text-orange-400 border-orange-500/30",
  a_venir: "bg-secondary text-foreground/80 border-border",
  // dead line : toujours en rouge (compte à rebours)
  ok: "bg-red-500/10 text-red-600 dark:text-red-400 border-red-500/30",
  proche: "bg-red-500/15 text-red-600 dark:text-red-400 border-red-500/50",
  depassee: "bg-red-600 text-white border-red-700",
};
